import React, { createContext, useContext, useEffect, useState } from 'react';
import {usePersistentState} from 'src/services/storage/use-persistent-state';

type LandlordLayoutContextType = {
    isSidebarCollapsed: boolean;
    setSidebarCollapsed: (isSidebarCollapsed: boolean) => void;
    sidebarWidth: number;
    isDrawerOpen: boolean;
    setDrawerOpen: (isDrawerOpen: boolean) => void;
}

// @ts-expect-error lateinit
const LandlordLayoutContext = createContext<LandlordLayoutContextType>();

export const useLandlordLayoutContext = () => {
    const context = useContext(LandlordLayoutContext);

    if (!context) {
        throw new Error('useLandlordLayoutContext must be used within a LandlordLayoutContext.Provider');
    }
    return context;
};

type Props = {
    children: React.ReactNode;
}

export default function LandlordLayoutProvider({ children }: Props) {
    const [isSidebarCollapsed, setSidebarCollapsed] = usePersistentState(
        'isSidebarCollapsed',
        false
    );
    const [sidebarWidth, setSidebarWidth] = useState(isSidebarCollapsed ? 60 : 230);
    const [isDrawerOpen, setDrawerOpen] = useState(false);

    useEffect(() => {
        if (window.innerWidth > 900) {
            setSidebarWidth(isSidebarCollapsed ? 60 : 230);
        } else {
            setSidebarWidth(0);
        }
    }, [isSidebarCollapsed]);
    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth > 900) {
                setSidebarWidth(isSidebarCollapsed ? 60 : 230);
            } else {
                setSidebarWidth(0);
            }
        };

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, [isSidebarCollapsed]);

    return (
        <LandlordLayoutContext.Provider value={{
            isSidebarCollapsed,
            setSidebarCollapsed,
            sidebarWidth,
            isDrawerOpen,
            setDrawerOpen,
        }}
        >
            {children}
        </LandlordLayoutContext.Provider>
    );
}
